import { getScrollBarStyles } from '../../../config/styles';
import styled from 'styled-components';
import useGeoMap from './useGeoMap';
import { useEffect, useMemo } from 'react';
import ControlPanel from './ControlPanel';
import ApplyColorAndTooltip from './ApplyColorAndTooltip';
import { theme } from '../../../styles/theme';
import { isScratchpadAnalysisId } from '../../../redux/utils/transientAnalysis';
import { uniqueId } from 'lodash';

interface IProps {
  analysisId: string;
}

const GeoMapContainer = styled.div<{ $isInScratchpad?: boolean }>`
  overflow: ${(props) => (props.$isInScratchpad ? 'visible' : 'auto')};
  width: auto;
  border: 1px solid ${theme.colors.border};
  ${getScrollBarStyles(4)};
`;

const GeoMapContent = styled.div`
  min-width: 600px;
`;

const GeoMap = ({ analysisId }: IProps) => {
  const isInScratchpad = isScratchpadAnalysisId(analysisId);

  /**
   * In scratchpad is possible to have the same analysis more than once.
   * In order the drawing functions of the chart to find the correct container
   * we need unique ids of those containers.
   */

  const containerId = useMemo(() => uniqueId('geo-map-'), []);

  const { initGeoMap, isGeoMapReady, svgRef } = useGeoMap({
    containerId,
  });

  // init the geo map and build the frame at launch
  useEffect(() => {
    initGeoMap();
  }, [initGeoMap]);

  return (
    <GeoMapContainer $isInScratchpad={isInScratchpad}>
      {/* containerId is for d3 to select the svg container and
          get the container rect and offset to generate the map */}
      <GeoMapContent id={containerId}>
        {/* Apply control panel for the initialized map */}
        <ControlPanel
          analysisId={analysisId}
          svgMapRef={svgRef}
          containerId={containerId}
          isGeoMapReady={isGeoMapReady}
        />
        {/* Apply color and tooltip for the initialized map */}
        <ApplyColorAndTooltip
          svgMapRef={svgRef}
          isGeoMapReady={isGeoMapReady}
          containerId={containerId}
        />
      </GeoMapContent>
    </GeoMapContainer>
  );
};

export default GeoMap;
